export const CREDIT_ADDITION_REASON_OPTIONS = [
  {
    value: 0,
    label: 'Credits added due to purchase of paid credit.',
    tag: 'credit_addition',
  },
  {
    value: 1,
    label: 'Credits added due to enrollment in degree.',
    tag: 'degree_enrollment',
  },
  {
    value: 2,
    label: 'Credits added back due to request cancellation.',
    tag: 'request_cancellation',
  },
  {
    value: 3,
    label: 'Credits added for onboarding to paid course.',
    tag: 'mentee_onboarding_addition',
  },
  {
    value: 4,
    label: 'Free credits added to the wallet.',
    tag: 'free_credit_addition',
  },
  {
    value: 5,
    label: 'Course resume journey milestone reward.',
    tag: 'resume_journey_milestone_reward',
  },
  {
    value: 6,
    label: 'Other Reason',
    tag: 'other',
  },
];
